import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FirebaseService } from 'src/app/shared/firebase.service';
import { AngularFireList } from '@angular/fire/database/database';
import { Task } from 'src/app/shared/task';

@Component({
  selector: 'app-collections',
  templateUrl: './collections.component.html',
  styleUrls: ['./collections.component.scss']
})
export class CollectionsComponent implements OnInit {
  collections: Task[][];
  collectionName: string;
  collectionNames: string[];
  constructor(
    private router: Router,
    private fireBaseService: FirebaseService,
  ) {
    // TODO MOVE COLLECTION TO SERVICE WITH ERROR HANDLER
    this.fireBaseService.collection = [];
    this.fireBaseService.getCollections().subscribe((data) => {
      this.collectionNames = Object.keys(data).filter(name => name !== 'Content');
      this.collections = data;
    });
  }
  // TODO UNTIL DESTROY AND ERROR HANDLER

  ngOnInit(): void {
  }

  next(): void {
    // tslint:disable-next-line: no-string-literal
    Object.values(this.collections[this.collectionName])
      .filter(el => !!el )
      .sort((a: any, b: any) => (a.order - b.order))
      .forEach((element: any) => {
      // tslint:disable-next-line: no-string-literal
      const task = this.collections['Content'].find(el => el && el.ID === element.ID);
      if (task) {
        this.fireBaseService.collection.push(new Task(
          task.ID,
          task.ru,
          task.en,
          task.type,
          task.targetOfPunishment,
          task.time,
          task.used,
          task.comments,
          task.replayable,
          task.wildy,
        ));
      }
    });
    this.router.navigate(['/', 'game']);
  }

  chooseCollection(collectionName: string): void {
    this.collectionName = collectionName;
  }

}
